import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatTab, MatTabContent, MatTabGroup, MatTabLabel } from "@angular/material/tabs";
import { QuestsComponent } from "../quests/quests.component";
import { QuestTemplatesComponent } from "../templates/quest-templates/quest-templates.component";
import { QuestSchedulesComponent } from "../schedules/quest-schedules//quest-schedules.component";

@Component({
    selector: "app-quests-manager",
    standalone: true,
    imports: [
        CommonModule,
        MatTabGroup,
        MatTab,
        MatTabLabel,
        MatTabContent,
        MatIcon,
        QuestsComponent,
        QuestTemplatesComponent,
        QuestSchedulesComponent,
    ],
    templateUrl: "./quests-manager.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestsManagerComponent {}
